export function Dashboard(): React.ReactElement {
  return <div data-testid="dashboard-page" />;
}
